import React, { useState } from 'react';
import { ProductPhotoProps } from './types';
import { Image, PlaceholderIcon, Wrapper } from './product-photo.styles';
import { InteriorDecoration } from '@vtbhome/juicyfront/indexIcon';

export const ProductPhoto: React.FC<ProductPhotoProps> = ({ imageUrl }) => {
    const [isShowImage, setIsShowImage] = useState(Boolean(imageUrl));

    const handleLoadError = () => {
        setIsShowImage(false);
    };

    return (
        <Wrapper>
            {!isShowImage && (
                <PlaceholderIcon>
                    <InteriorDecoration />
                </PlaceholderIcon>
            )}
            {isShowImage && <Image src={imageUrl} onError={handleLoadError} />}
        </Wrapper>
    );
};
